import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import AuthCallback from "@/components/AuthCallback";
import Layout from "@/components/Layout";
import api from "@/lib/api";
import { initPwa } from "@/lib/pwa";

import Landing from "@/pages/Landing";
import Auth from "@/pages/Auth";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Dashboard from "@/pages/Dashboard";
import Topics from "@/pages/Topics";
import TopicDetail from "@/pages/TopicDetail";
import AskAI from "@/pages/AskAI";
import Exams from "@/pages/Exams";
import ExamTake from "@/pages/ExamTake";
import Progress from "@/pages/Progress";
import Subscribe from "@/pages/Subscribe";
import Admin from "@/pages/Admin";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import PaymentHistory from "@/pages/PaymentHistory";

const wrap = (el) => (
  <ProtectedRoute>
    <Layout>{el}</Layout>
  </ProtectedRoute>
);

function PageTracker() {
  const location = useLocation();
  useEffect(() => {
    api.post("/track", { path: location.pathname, referrer: document.referrer || "" }).catch(() => {});
  }, [location.pathname]);
  return null;
}

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;

  return (
    <>
      <PageTracker />
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/giris" element={<Auth />} />
        <Route path="/sifremi-unuttum" element={<ForgotPassword />} />
        <Route path="/sifre-sifirla" element={<ResetPassword />} />
        <Route path="/panel" element={wrap(<Dashboard />)} />
        <Route path="/konular" element={wrap(<Topics />)} />
        <Route path="/konular/:id" element={wrap(<TopicDetail />)} />
        <Route path="/soru-cevap" element={wrap(<AskAI />)} />
        <Route path="/denemeler" element={wrap(<Exams />)} />
        <Route path="/denemeler/:id" element={wrap(<ExamTake />)} />
        <Route path="/ilerleme" element={wrap(<Progress />)} />
        <Route path="/abonelik" element={wrap(<Subscribe />)} />
        <Route path="/odemelerim" element={wrap(<PaymentHistory />)} />
        <Route
          path="/admin"
          element={
            <ProtectedRoute adminOnly>
              <Layout><Admin /></Layout>
            </ProtectedRoute>
          }
        />
        <Route path="/payment/success" element={wrap(<PaymentSuccess />)} />
        <Route path="/payment/cancel" element={wrap(<PaymentCancel />)} />
      </Routes>
    </>
  );
}

function App() {
  useEffect(() => { initPwa(); }, []);
  return (
    <BrowserRouter>
      <AuthProvider>
        <Toaster position="top-center" richColors />
        <AppRouter />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
